import styled from 'styled-components';

export const MainEngineSectionWrapper = styled.div`
    .slip-details,
    .sfoc-details {
        top: 20px;
        position: absolute;
        z-index: 100000;
        background-color: #f3f3d9;
        border: 1px solid #78785e;
    }
    .slip-details-hidden,
    .sfoc-details-hidden {
        display: none;
    }
    .slip-details-expanded,
    .sfoc-details-expanded {
        display: block;
        padding: 10px;
    }
    .slip-detail,
    .sfoc-detail {
        display: flex;
    }
    .slip-details-button-wrapper {
        position: relative;
        left: 28px;
        top: -23px;
        border: 0;
    }
    .sfoc-details-button-wrapper {
        position: relative;
        left: 38px;
        top: -23px;
        border: 0;
    }
    .slip-details-button,
    .sfoc-details-button {
        display: contents;
        height: 20px;
        width: 20px;
    }
    .input-and-icon {
        position: relative;
        height: 20px;
    }
`;
